export default "__VITE_ASSET__CnMgMGm4__"